import React from 'react';

import t from '../../../labels/labelling-utils';
import { isLive } from '../../../utils/match-status';
import { makeClassNames } from '../../../utils/styles';
import IconCalendar from '../../atoms/icons/icon-calendar';
import TeamMatchCardWrapper from '../../atoms/outlined-card/outlined-card';
import Text from '../../atoms/text/text';
import TeamMatchCardSkeleton from '../../molecules/team-match-card-skeleton/team-match-card-skeleton';
import TeamMatchCard, { ITeamMatchCard } from '../../organisms/team-match-card/team-match-card';
import './team-last-next-match.scss';

type CustomTrackingData =
  | {
      dataAttribute: string;
      lastMatch: string;
      nextMatch: string;
    }
  | undefined;
export interface ITeamLastNextMatch {
  teamId?: string;
  lastMatch: ITeamMatchCard | null | undefined;
  nextMatch: ITeamMatchCard | null | undefined;
  isLoading?: boolean;
  customTrackingData: CustomTrackingData;
  countdownEnabled?: boolean;
}

const getLastMatchTrackingData = (trackingData: CustomTrackingData): object | undefined =>
  trackingData ? { [trackingData.dataAttribute]: trackingData.lastMatch } : undefined;

const getNextMatchTrackingData = (trackingData: CustomTrackingData): object | undefined =>
  trackingData ? { [trackingData.dataAttribute]: trackingData.nextMatch } : undefined;

const classNames = () =>
  makeClassNames({
    root: 'team-next-last-match',
    cardWrapper: 'team-next-last-match__card-wrapper',
    title: 'team-next-last-match__title',
    emptyContent: 'team-next-last-match__empty-content',
    emptyIconWrapper: 'team-next-last-match__empty-icon-wrapper',
  });

const TeamLastNextMatch = ({
  lastMatch,
  nextMatch,
  isLoading,
  customTrackingData,
  countdownEnabled,
}: ITeamLastNextMatch) => {
  const cn = classNames();
  const nextMatchTitle =
    nextMatch && isLive(nextMatch.status) ? t('team.next-last-match.next-live') : t('team.next-last-match.next');

  const emptyCard = (
    <TeamMatchCardWrapper>
      <div className={cn.emptyContent}>
        <div className={cn.emptyIconWrapper}>
          <IconCalendar size="xlarge" color="medium-light" />
        </div>
        <Text color="blue" fontSize="18" fontWeight="500">
          {t('team.next-last-match.empty')}
        </Text>
      </div>
    </TeamMatchCardWrapper>
  );

  const getTeamMatchCard = (
    title: string,
    match: ITeamMatchCard | null | undefined,
    dataAttributes: object | undefined
  ) => (
    <div className={cn.cardWrapper}>
      <h2 className={cn.title}>{title}</h2>
      {isLoading && <TeamMatchCardSkeleton />}
      {!isLoading && match ? (
        <TeamMatchCard {...match} dataAttributes={dataAttributes} countdownEnabled={countdownEnabled} />
      ) : (
        !isLoading && emptyCard
      )}
    </div>
  );

  return (
    <div className={cn.root}>
      {getTeamMatchCard(t('team.next-last-match.previous'), lastMatch, getLastMatchTrackingData(customTrackingData))}
      {getTeamMatchCard(nextMatchTitle, nextMatch, getNextMatchTrackingData(customTrackingData))}
    </div>
  );
};

export default TeamLastNextMatch;
